import { SUPPORTED_DATA_TYPES, DATA_TYPE_SUPPORTED_VIEW_TYPES_MAP } from '@/domains/detail/space/constants';
import _ from 'lodash';
import { useDetailRouter } from './use-detail-router';
import { useDetailRoute } from './use-detail-route';
import { ViewType } from '@/domains/base/enums/view-type';
import { DataType } from '@/domains/base/enums/data-type';
import { useRouter } from 'vue-router/composables';
import { useDefaultViewType } from '@/presentation/composables/view-type/use-default-view-type';
import { useUserInfo } from '@/presentation/composables/user/use-user-info';
import { LEGACY_VIEW_TYPE_MAP_REVERSE } from '@/domains/detail/dataset/constants';
export const useDetailRouterValidate = () => {
    const router = useRouter();
    const { goToHome } = useDetailRouter();
    const { spaceId, dataType, viewType } = useDetailRoute();
    const { defaultViewType } = useDefaultViewType();
    const { viewTypeList } = useUserInfo();
    const initDetailRouter = (folderId) => {
        if (!spaceId.value) {
            goToHome();
            return;
        }
        if (!folderId) {
            return;
        }
        let _dataType = dataType.value;
        let _viewType = LEGACY_VIEW_TYPE_MAP_REVERSE[viewType.value] ||
            viewType.value ||
            defaultViewType.value;
        if (!_dataType || !_.includes(SUPPORTED_DATA_TYPES, _dataType)) {
            _dataType = DataType.PATENT;
        }
        const isValidateViewType = (viewType) => {
            return _.includes(DATA_TYPE_SUPPORTED_VIEW_TYPES_MAP[_dataType], viewType)
                && _.includes(viewTypeList.value, viewType);
        };
        if (!isValidateViewType(_viewType)) {
            _viewType = isValidateViewType(defaultViewType.value) ? defaultViewType.value : ViewType.TABLE;
        }
        const query = _.cloneDeep(router.currentRoute.query);
        query.folderId = folderId;
        router.replace({
            name: 'detailContent',
            params: {
                dataType: _dataType,
                viewType: _viewType,
            },
            query,
        });
    };
    return {
        initDetailRouter,
    };
};
